import _ from 'lodash';
import {
    FETCH_MTOKNA_OWNER_POINTS,
    CLEAN_MTOKNA_OWNER_POINTS,
    CREATE_MTOKNA_OWNER_POINT,
    DELETE_MTOKNA_OWNER_POINT,
} from './types';
import { request, __ } from '../functions';

export const fetchMtoknaOwnerPoints = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/ownerPoints', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_OWNER_POINTS, payload: data });
    });
};

export const createMtoknaOwnerPoint = (screen, id) => {
    return dispatch => request(`/mtokna/createPointRemove/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa vypnúť odberné miesto'));
            return;
        }

        screen.showSnackbar('success', __('Odberné miesto bolo vypnuté'));

        dispatch({ type: CREATE_MTOKNA_OWNER_POINT, payload: { id } });
    });
};

export const deleteMtoknaOwnerPoint = (screen, id) => {
    return dispatch => request(`/mtokna/removePointRemove/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zapnúť odberné miesto'));
            return;
        }

        screen.showSnackbar('success', __('Odberné miesto bolo zapnuté'));

        dispatch({ type: DELETE_MTOKNA_OWNER_POINT, payload: { id } });
    });
};

export const cleanMtoknaOwnerPoints = () => ({ type: CLEAN_MTOKNA_OWNER_POINTS });
